import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

interface GridCellContainerProps {
  rowHeight: string;
}

export const GridCellContainer = styled(Box)<GridCellContainerProps>`
  ${({ rowHeight }) =>
    css`
      height: ${rowHeight}px;
      button {
        height: 26px;
        border-radius: 0px;
        border: none;
      }
    `}
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  font-size: ${({ theme }) => theme.fontSizes[300]};
  & button:focus {
    border-color: transparent;
    box-shadow: none;
  }
  & > div {
    flex-shrink: 1;
  }
`;
